import {
  calculateInstallmentWork,
  callMe,
  feedback,
  productAvailability,
  productBargain,
  productCheaper,
  productCredit,
  productQuickOrder,
  projectingRequest,
  storePartners,
} from '@/js/api/forms.ts';
import { review } from '@/js/api/products.ts';
import { reachGoal } from '@/js/goal.ts';
import { getLocaleValue } from '@/js/helper/locale.ts';
import { ERROR_REQUEST_TEXT, showErrorNotify } from '@/js/notification.ts';
import { Captcha, CAPTCHA_CONTAINER_SELECTOR, RECAPTCHA_FIELD_NAME } from '@/js/recaptcha.ts';

const FORM_SELECTOR = '.js-form';
const SUBMIT_BUTTON_SELECTOR = 'button[type="submit"]';
const LOADING_CLASS = 'loading';
const SUCCESS_CLASS = 'success';

const formElements = document.querySelectorAll<HTMLFormElement>(FORM_SELECTOR);

async function productReview(data: FormData) {
  const productId = data.get('productId');
  return review(Number(productId), data);
}

async function fetchForm(name: string, data: FormData) {
  switch (name) {
    case 'available':
      return productAvailability(data);
    case 'cheaper':
      return productCheaper(data);
    case 'bargain':
      return productBargain(data);
    case 'call-me':
      return callMe(data);
    case 'feedback':
      return feedback(data);
    case 'credit':
      return productCredit(data);
    case 'quick-order':
      return productQuickOrder(data);
    case 'projecting':
      return projectingRequest(data);
    case 'calculate-work':
      return calculateInstallmentWork(data);
    case 'partners':
      return storePartners(data);
    case 'product-review':
      return productReview(data);
    default:
      return null;
  }
}

export function initForms() {
  for (const formElement of formElements) {
    const { formName = '', goalName = '' } = formElement.dataset;
    const buttonElement = formElement.querySelector<HTMLButtonElement>(SUBMIT_BUTTON_SELECTOR);
    const captchaContainer = formElement.querySelector<HTMLElement>(CAPTCHA_CONTAINER_SELECTOR);
    const captcha = captchaContainer ? new Captcha(captchaContainer) : null;
    // eslint-disable-next-line ts/no-misused-promises
    formElement.addEventListener('submit', async (event) => {
      event.preventDefault();
      if (!captcha) {
        showErrorNotify({ text: getLocaleValue('confirm_the_captcha') });
        return;
      }
      try {
        buttonElement?.classList.add(LOADING_CLASS);
        captcha.render();
        const token = await captcha.execute();
        const formData = new FormData(formElement);
        formData.set(RECAPTCHA_FIELD_NAME, token);
        const response = await fetchForm(formName, formData);
        if (response && response.data && response.data.success) {
          formElement.classList.add(SUCCESS_CLASS);
          captcha.reset();

          if (goalName) {
            reachGoal(goalName);
          }
        }
        else {
          showErrorNotify({ text: ERROR_REQUEST_TEXT });
        }
      }
      catch (e) {
        showErrorNotify({ text: ERROR_REQUEST_TEXT });
        console.error(e);
      }
      finally {
        buttonElement?.classList.remove(LOADING_CLASS);
      }
    });
  }
}
